module.exports = __webpack_public_path__ + "img/banner-title-bg01.3beb448d.svg";